// styles
import { getAvailableTimes } from './economyUtils';
// import {
//   useSoFormStepsApi,
//   useSoFormStepsState,
// } from 'refactored/features/soForm/SoForm.context';
// import moment from 'moment-timezone';
import SoHourPicker from './SoHourPicker';
import moment from 'moment-timezone';
import { useSoFormStepsApi } from 'refactored/features/soForm/SoForm.context';

const DEFAULT_TRAVEL_TIME = 60;

const getUpdateTimesBecauseOfPickupFromChanged = ({
  originalTimes,
  item,
  travelTimeInMinutes,
}) => {
  const newTimes = { ...originalTimes };

  // pickup from
  newTimes.pickup_time_from = item.time;

  //   pickup to
  if (
    moment(originalTimes.pickup_time_to).isBefore(
      newTimes.pickup_time_from,
      'minutes'
    )
  ) {
    newTimes.pickup_time_to = newTimes.pickup_time_from;
  }

  // dropoff from
  const minDropoffFrom = moment(newTimes.pickup_time_from)
    .add(travelTimeInMinutes, 'minutes')
    .toJSON();
  if (
    moment(originalTimes.dropoff_time_from).isBefore(minDropoffFrom, 'minutes')
  ) {
    newTimes.dropoff_time_from = minDropoffFrom;
  }

  // dropoff to
  const minDropoffTo = moment(newTimes.pickup_time_to)
    .add(travelTimeInMinutes, 'minutes')
    .toJSON();
  if (moment(originalTimes.dropoff_time_to).isBefore(minDropoffTo, 'minutes')) {
    newTimes.dropoff_time_to = minDropoffTo;
  }
  return newTimes;
};

const getUpdateTimesBecauseOfPickupToChanged = ({
  originalTimes,
  item,
  travelTimeInMinutes,
}) => {
  const newTimes = { ...originalTimes };
  // pickup from
  // is the same

  // pickup to
  newTimes.pickup_time_to = item.time;

  //   dropoff from
  //   is the same

  // dropoff to
  const minDropoffTo = moment(newTimes.pickup_time_to)
    .add(travelTimeInMinutes, 'minutes')
    .toJSON();
  if (moment(originalTimes.dropoff_time_to).isBefore(minDropoffTo, 'minutes')) {
    newTimes.dropoff_time_to = minDropoffTo;
  }
  return newTimes;
};

const getUpdateTimesBecauseOfDropoffFromChanged = ({
  originalTimes,
  item,
  travelTimeInMinutes,
}) => {
  const newTimes = { ...originalTimes };
  // pickup from
  // is the same

  // pickup to
  // is the same

  // dropoff from
  newTimes.dropoff_time_from = item.time;

  //   dropoff to

  if (
    moment(originalTimes.dropoff_time_to).isBefore(
      newTimes.dropoff_time_from,
      'minutes'
    )
  ) {
    newTimes.dropoff_time_to = newTimes.dropoff_time_from;
  }
  return newTimes;
};

const getUpdateTimesBecauseOfDropoffToChanged = ({
  originalTimes,
  item,
  travelTimeInMinutes,
}) => {
  const newTimes = { ...originalTimes };
  // pickup from
  // is the same

  // pickup to
  // is the same

  // dropoff from
  // is the same

  //   dropoff to
  newTimes.dropoff_time_to = item.time;
  return newTimes;
};

const SoExpressHourPicker = ({ candidate, isPickup }) => {
  const stepsApi = useSoFormStepsApi();
  const shipment = candidate.formData.quotePayload.shipments[0];
  const travelTimeInMinutes =
    candidate.formData.travelTimeInMinutes || DEFAULT_TRAVEL_TIME;

  // pickup From goes from proposed minTime to 23:30
  const pickupFromMinTime = candidate.formData.minTime;
  const pickupFromMaxTime = moment(candidate.formData.minTime)
    .hours(23)
    .minutes(30)
    .toJSON();
  const availableTimesPickupFrom = getAvailableTimes({
    minTime: pickupFromMinTime,
    maxTime: pickupFromMaxTime,
    itemIncrementInMinutes: 30,
  });

  // pickup to goes from pickupFrom to 07:00 of next day
  const pickupToMinTime = shipment.pickup_time_from;
  const pickupToMaxTime = moment(candidate.formData.minTime)
    .add(1, 'day')
    .hours(7)
    .toJSON();
  const availableTimesPickupTo = getAvailableTimes({
    minTime: pickupToMinTime,
    maxTime: pickupToMaxTime,
    itemIncrementInMinutes: 30,
  });

  // dropoff From goes from pickupFrom + travelTime to 23:30
  const dropoffFromMinTime = moment(shipment.pickup_time_from)
    .add(travelTimeInMinutes, 'minutes')
    .toJSON();
  const dropoffFromMaxTime = moment(shipment.pickup_time_from)
    .add(1, 'day')
    .hours(7)
    .minutes(0)
    .toJSON();
  const availableTimesDropoffFrom = getAvailableTimes({
    minTime: dropoffFromMinTime,
    maxTime: dropoffFromMaxTime,
    itemIncrementInMinutes: 30,
  });

  //   dropoff To goes from pickupTo + travelTime to 07:00 of next day
  const dropoffFromToMinTime = moment(shipment.pickup_time_to)
    .add(travelTimeInMinutes, 'minutes')
    .toJSON();
  const dropoffFromToMaxTime = moment(shipment.pickup_time_from)
    .add(1, 'day')
    .hours(23)
    .minutes(30)
    .toJSON();
  const availableTimesDropoffTo = getAvailableTimes({
    minTime: dropoffFromToMinTime,
    maxTime: dropoffFromToMaxTime,
    itemIncrementInMinutes: 30,
  });

  const setPickupFromHour = (item) => {
    const {
      pickup_time_from,
      pickup_time_to,
      dropoff_time_from,
      dropoff_time_to,
    } = candidate.formData.quotePayload.shipments[0];

    const originalTimes = {
      pickup_time_from,
      pickup_time_to,
      dropoff_time_from,
      dropoff_time_to,
    };
    const newTimes = getUpdateTimesBecauseOfPickupFromChanged({
      originalTimes,
      item,
      travelTimeInMinutes,
    });
    stepsApi.setExpressHours({ newTimes, candidate });
  };

  const setPickupToHour = (item) => {
    const {
      pickup_time_from,
      pickup_time_to,
      dropoff_time_from,
      dropoff_time_to,
    } = candidate.formData.quotePayload.shipments[0];

    const originalTimes = {
      pickup_time_from,
      pickup_time_to,
      dropoff_time_from,
      dropoff_time_to,
    };
    const newTimes = getUpdateTimesBecauseOfPickupToChanged({
      originalTimes,
      item,
      travelTimeInMinutes,
    });
    stepsApi.setExpressHours({ newTimes, candidate });
  };

  const setDropoffFromHour = (item) => {
    const {
      pickup_time_from,
      pickup_time_to,
      dropoff_time_from,
      dropoff_time_to,
    } = candidate.formData.quotePayload.shipments[0];

    const originalTimes = {
      pickup_time_from,
      pickup_time_to,
      dropoff_time_from,
      dropoff_time_to,
    };
    const newTimes = getUpdateTimesBecauseOfDropoffFromChanged({
      originalTimes,
      item,
      travelTimeInMinutes,
    });
    stepsApi.setExpressHours({ newTimes, candidate });
  };

  const setDropoffToHour = (item) => {
    const {
      pickup_time_from,
      pickup_time_to,
      dropoff_time_from,
      dropoff_time_to,
    } = candidate.formData.quotePayload.shipments[0];

    const originalTimes = {
      pickup_time_from,
      pickup_time_to,
      dropoff_time_from,
      dropoff_time_to,
    };
    const newTimes = getUpdateTimesBecauseOfDropoffToChanged({
      originalTimes,
      item,
      travelTimeInMinutes,
    });
    stepsApi.setExpressHours({ newTimes, candidate });
    return;
  };

  const timeFrom = isPickup
    ? shipment.pickup_time_from
    : shipment.dropoff_time_from;

  const timeTo = isPickup ? shipment.pickup_time_to : shipment.dropoff_time_to;

  const selectFromFunction = isPickup ? setPickupFromHour : setDropoffFromHour;

  const selectToFunction = isPickup ? setPickupToHour : setDropoffToHour;

  const availableTimesFrom = isPickup
    ? availableTimesPickupFrom
    : availableTimesDropoffFrom;

  const availableTimesTo = isPickup
    ? availableTimesPickupTo
    : availableTimesDropoffTo;

  return (
    <SoHourPicker
      timeFrom={timeFrom}
      timeTo={timeTo}
      availableTimesFrom={availableTimesFrom}
      availableTimesTo={availableTimesTo}
      selectFromFunction={selectFromFunction}
      selectToFunction={selectToFunction}
    />
  );
};

export default SoExpressHourPicker;
